import PropTypes from 'prop-types';
import getRoute from 'components/searchAds/SearchLayout/getRoute';

import * as routeActions from './actions';
import mapStateToProps from './mapStateToProps';

const propTypes = {
  beforeExtraFiltersOpened: PropTypes.func.isRequired,
  breadcrumbs: PropTypes.array.isRequired,
  breadcrumbsHtml: PropTypes.string.isRequired,
  changeFilters: PropTypes.func.isRequired,
  changePage: PropTypes.func.isRequired,
  changeSort: PropTypes.func.isRequired,
  cms: PropTypes.object,
  initialForm: PropTypes.object.isRequired,
  userSearchType: PropTypes.string.isRequired,
  withInitialAdResultsAmount: PropTypes.bool.isRequired,
  withPromoBanner: PropTypes.bool.isRequired,
  withWelcomeBanner: PropTypes.bool.isRequired,
  withExtraFilters: PropTypes.bool.isRequired,
};

const { Component, actions, reducer } = getRoute({
  mapStateToProps,
  propTypes,
  routeActions,
});

export { actions, reducer };
export default Component;
